module.exports = __webpack_public_path__ + "static/media/cargo-ship.0e4ee009.jpg";